<script setup lang="ts">
import { computed } from 'vue';
import { BFormCheckbox } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData, ICheckboxColumn } from '../types';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
}>();
const emit = defineEmits(['update:modelValue', 'change']);

const col = computed(() => props.column as ICheckboxColumn);

const currentValue = computed({
  get: () => !!props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const isDisabled = computed(() => {
  return col.value.editorIsDisabled
    ? col.value.editorIsDisabled(props.row)
    : false;
});
</script>

<template>
  <div class="d-flex justify-content-center">
    <BFormCheckbox
      v-model="currentValue"
      :name="col.name"
      :disabled="isDisabled"
      @change="emit('change', currentValue)"
      @click.stop
    />
  </div>
</template>
